var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "gallery-slider" },
      [
        _c(
          "swiper",
          {
            ref: "gallery-slider",
            staticClass: "h-100",
            attrs: { options: _vm.swiperOptions },
          },
          _vm._l(_vm.slides, function (slide, index) {
            return _c(
              "swiper-slide",
              { key: index },
              [
                _c(
                  "bg-image",
                  {
                    staticClass: "h-100",
                    attrs: {
                      src: slide.high,
                      placeholder: slide.low,
                      "lazy-load": false,
                    },
                  },
                  [
                    _c("div", { staticClass: "caption" }, [
                      _vm._v(_vm._s(slide.title)),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "nav-buttons" }, [
          _c(
            "button",
            {
              staticClass: "btn-prev",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.slidePrev()
                },
              },
            },
            [_c("i", { staticClass: "icon-arrow-medium-left" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-next",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.slideNext()
                },
              },
            },
            [_c("i", { staticClass: "icon-arrow-medium-right" })]
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gallery-slider-thumbs" },
      [
        _c(
          "swiper",
          {
            ref: "gallery-slider-thumbs",
            attrs: { options: _vm.swiperOptionsThumbs },
          },
          _vm._l(_vm.slides, function (slide, index) {
            return _c("swiper-slide", { key: index }, [
              _c(
                "button",
                { attrs: { type: "button" } },
                [
                  _c("bg-image", {
                    attrs: {
                      src: slide.thumb,
                      placeholder: slide.low,
                      "lazy-load": false,
                    },
                  }),
                ],
                1
              ),
            ])
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "nav-buttons" }, [
          _c(
            "button",
            {
              staticClass: "btn-prev",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.thumbPrev()
                },
              },
            },
            [_c("i", { staticClass: "icon-arrow-medium-left" })]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn-next",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.thumbNext()
                },
              },
            },
            [_c("i", { staticClass: "icon-arrow-medium-right" })]
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }